import React from 'react';

// Props Interface
interface IconButtonProps {
  icon: React.ReactNode; // Accepts any React component as an icon
  onClick: () => void; // Click handler
  className?: string; // Custom styling for button
  disabled?: boolean;
}

// Reusable Icon Button Component
const ReusableIconButton: React.FC<IconButtonProps> = ({
  icon,
  onClick,
  className,
  disabled,
}) => {
  return (
    <button
      onClick={onClick}
      className={`p-2 border rounded-md hover:bg-gray-100 ${className}`}
      disabled={disabled}
    >
      {/* Render dynamic icon passed as a prop */}
      {icon}
    </button>
  );
};

export default ReusableIconButton;
